import { Pipe, PipeTransform } from "@angular/core";
import { ContactDetails } from "../../models/contact/contactDetails";

@Pipe({
  name: "addressSingleLine",
})
export class AddressSingleLinePipe implements PipeTransform {
  transform(value: ContactDetails, ...args: any[]): any {
    if (!value) {
      return "";
    }
    return `${value.address1 ? value.address1 : ""} ${
      value.city ? `, ${value.city}` : ""
    }${value.state ? `, ${value.state}  ` : ""} ${
      value.zip ? `${value.zip}` : ""
    } ${value.zipExtension ? `-${value.zipExtension}` : ""}${
      value.county ? `, ${value.county}` : ""
    }`;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/address-single-line.pipe.ts